import React, {Component} from 'react';
import { FormGroup, FormControl, Col, Button, ControlLabel } from 'react-bootstrap';
import axios from 'axios';
import {ROOT_URL} from  '../../redux/actions/';

class SendMessageForm extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			email: '',
			telephone: '',
			message: ''
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.clearForm = this.clearForm.bind(this);
	}

	handleChange(event, type) {
        this.setState({
            [type]: event.target.value
        })
	}

	async handleSubmit(event) {
		try {
			const { name, email,telephone,message } = this.state;

			event.preventDefault();

			const response = await axios({
				method: "POST", 
				url:`${ROOT_URL}/email/message`, 
				data: {
					name: name,   
					email: email,  
					telephone: telephone,
					message: message
				}
			});
			alert('Thank you for your submission');
			this.clearForm();
		} catch (error) {
			console.log(error.response.data);
            alert(error.response.data);
		}
	}

	clearForm () {
		this.setState({
			name: '',
			email: '',
			telephone: '',
			message: ''
		});
	}

	render() {
		return (
	      	<div>
		      	<h4 id="xf"><b>SEND A MESSAGE</b></h4>
				  <div id="sendMessageFormForm">
					<FormGroup id='messageForm'>
						<Col componentClass={ControlLabel} sm={2}>
							Name:
						</Col>
						<Col sm={15}>
							<FormControl 
								id="name" 
								className="formField" 
								type="text" 
								placeholder="Name" 
								value={this.state.name} 
								onChange={(e)=>this.handleChange(e, 'name')}
							/>
						</Col>
					</FormGroup>
					<FormGroup>
						<Col componentClass={ControlLabel} sm={2}>
							Email:
						</Col>
						<Col sm={15}>
							<FormControl 
								id="email" 
								className="formField" 
								type="email" 
								placeholder="Email" 
								value={this.state.email} 
								onChange={(e)=>this.handleChange(e, 'email')}
							/>
						</Col>
					</FormGroup>
					<FormGroup>
						<Col componentClass={ControlLabel} sm={2}>
							Telephone:
						</Col>
						<Col sm={15}>
							<FormControl 
								id="telephone" 
								className="formField" 
								type="text" 
								placeholder="Telephone" 
								value={this.state.telephone} 
								onChange={(e)=>this.handleChange(e, 'telephone')} 
							/>
						</Col>
					</FormGroup>
					<FormGroup>
						<Col componentClass={ControlLabel} sm={2}>
							Message:
						</Col>
						<Col sm={15}>
							<FormControl 
								id="message" 
								className="formField textarea" 
								componentClass="textarea"
								placeholder="Message" 
								value={this.state.message} 
								onChange={(e)=>this.handleChange(e, 'message')} 
							/>
						</Col>
					</FormGroup>
					<FormGroup>
						<Col smOffset={2} sm={10}>
							<Button type="submit" onClick={this.handleSubmit}>Send</Button>
						</Col>
					</FormGroup>
				</div>
	      	</div>
	    );
	}
}

export default SendMessageForm;



// WEBPACK FOOTER //
// ./src/components/contactUs/sendMessageForm.js